package com.kinoshazam.uiKit.components.videoItem

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.image.ImageUiKitState
import com.kinoshazam.uiKit.components.image.UiKitImage
import com.kinoshazam.uiKit.theme.Medium
import com.kinoshazam.uiKit.theme.UiKitTheme
import com.kinoshazam.uiKit.theme.smallRadius

@Composable
fun CompactVideoItem(
    state: VideoState,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier
            .size(width = 130.dp, height = 231.dp)
            .background(UiKitTheme.colors.color_4)
            .clip(shape = smallRadius)
            .clickable {
                state.onAction(state.id)
            }
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(190.dp)
        ) {

            UiKitImage(
                state = ImageUiKitState(
                    url = state.image,
                    placeholder = state.placeHolder,
                    placeholderColor = state.placeHolderColor,
                    contentScale = ContentScale.Crop,
                ),
                modifier = Modifier
                    .align(Alignment.Center)
                    .padding(start = 1.dp, end = 1.dp, top = 1.dp)
                    .clip(shape = RoundedCornerShape(topStart = 1.dp, topEnd = 1.dp))
            )
        }

        Text(
            text = state.title,
            color = UiKitTheme.colors.color_2,
            textAlign = TextAlign.Start,
            maxLines = 2,
            overflow = TextOverflow.Ellipsis,
            style = Medium,
            modifier = Modifier
                .fillMaxWidth()
                .defaultMinSize(minHeight = 40.dp)
                .wrapContentHeight()
                .padding(horizontal = 5.dp)
        )
    }
}
